import styled from "styled-components";
import { media } from "components/designV2/breakpoints";
import { Radius, Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const SettingsStampClockGrid = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
`;

export const FormStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    margin-top: 10px;
  }

  h4 {
    align-self: flex-start;
  }

  a {
    margin: 0 0 20px 0;
  }

  textarea {
    margin: 0;
    max-height: 300px;
    resize: none;
  }

  ${media.tablet} {
    grid-column: 3/4;
  }
`;

export const CheckboxText = styled.p`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue1};
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  p {
    &:hover {
      cursor: pointer;
      color: ${ColorV2.Blue5};
    }
  }
  checkbox .checked {
    color: ${ColorV2.Blue5};
  }
`;

export const TimeInputContainer = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;

  span {
    margin-bottom: 10px;
  }
`;

export const DividerLine = styled.hr`
  border: none;
  border-top: 2px solid ${ColorV2.Blue6};
  margin: 25px 0;
  align-self: center;
  width: 100%;
`;

export const LocalStampClockContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  margin: 0px;
`;

export const StampClockCreateActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${Spacing.sm}px;
`;

export const StampClockAccessHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${Spacing.md}px;
  flex-wrap: wrap;

  > div:first-child {
    min-width: 0;
    max-width: 100%;
  }
`;

export const StampClockMetaLabel = styled.p`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
  margin: 0 0 ${Spacing.xs}px;
`;

export const StampClockLinkRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.md}px;
  flex-wrap: wrap;
`;

export const StampClockLink = styled.a`
  ${TypographyV2.b2}
  color: ${ColorV2.ElectricBlue};
  overflow-wrap: anywhere;
`;

export const StampClockUserList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;

  ${media.tablet} {
    width: 620px;
    max-width: 100%;
  }
`;

export const StampClockUserRow = styled.li`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  align-items: center;
  background: ${ColorV2.Blue7};
  border-radius: ${Radius.lg}px;
  display: grid;
  gap: ${Spacing.md}px;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.4fr) auto;
  min-height: 48px;
  padding: ${Spacing.sm}px ${Spacing.md}px;
`;

export const StampClockUserName = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  overflow-wrap: anywhere;
`;

export const StampClockEmptyText = styled.span`
  grid-column: 1 / -1;
`;

export const StampClockUserEmail = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  overflow-wrap: anywhere;
`;

export const StampClockCreateDescription = styled.p`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  margin: 0;
`;

export const StampClockCreatedEmail = styled.p`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  margin: 0;
`;
